import panzoom from 'panzoom';
import { _breakP } from '../../js/lib/utils.js';

export default class zoomFigure {
  constructor() {
    this.zoomFunc();
  }

  zoomFunc() {
    const $mapElem = document.querySelectorAll('.js-panzoom');

    if ($mapElem.length) {
      $mapElem.forEach(elm => {
        const $onlyMode = elm.parentNode.dataset.mode;

        function zoom() {
          const $plusBtn =
            elm.nextElementSibling.querySelectorAll('.js-panzoom-in')[0];
          const $minusBtn =
            elm.nextElementSibling.querySelectorAll('.js-panzoom-out')[0];
          let eventType, initZoom, initPosX, initPosY;
          if (_breakP.SP) {
            eventType = 'touchstart';
            initZoom = Number(elm.dataset.initZoom);
            initPosX = Number(elm.dataset.initPosX);
            initPosY = Number(elm.dataset.initPosY);
          } else {
            eventType = 'click';
            initZoom = Number(elm.dataset.initZoomPc)
              ? Number(elm.dataset.initZoomPc)
              : 1;
            initPosX = Number(elm.dataset.initPosXPc)
              ? Number(elm.dataset.initPosXPc)
              : 0;
            initPosY = Number(elm.dataset.initPosYPc)
              ? Number(elm.dataset.initPosYPc)
              : 0;
          }
          const panzoomMap = panzoom(elm.querySelector('.zoomFigure__inner'), {
            maxZoom: 3,
            minZoom: 1,
            initialX: initPosX,
            initialY: initPosY,
            initialZoom: initZoom,
            bounds: true,
            boundsPadding: 1,
            beforeWheel: function (e) {
              const shouldIgnore = !e.altKey;
              return shouldIgnore;
            }
          });

          // ズームイン機能
          const zoomIn = () => {
            panzoomMap.smoothZoom(0, 0, 1.5);
          };

          // ズームアウト機能
          const zoomOut = () => {
            panzoomMap.smoothZoom(0, 0, 0.5);
          };

          // クリックイベント
          $plusBtn.addEventListener(eventType, zoomIn);
          $minusBtn.addEventListener(eventType, zoomOut);

          // キーボードイベント（エンターキー対応）
          $plusBtn.addEventListener('keydown', e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              zoomIn();
            }
          });

          $minusBtn.addEventListener('keydown', e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              zoomOut();
            }
          });

          // フォーカス管理の改善
          // 地図要素自体にもフォーカス可能にする
          elm.setAttribute('tabindex', '0');
          elm.setAttribute('role', 'img');
          elm.setAttribute('aria-label', 'ズーム可能な地図');

          // 地図要素のキーボード操作
          elm.addEventListener('keydown', e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              // 地図がフォーカスされた時は、最初のズームボタンにフォーカスを移動
              $plusBtn.focus();
            }
          });
        }

        if ($onlyMode === 'pc') {
          if (!_breakP.SP) {
            zoom();
          }
        } else if ($onlyMode === 'sp') {
          if (_breakP.SP) {
            zoom();
          }
        } else if (!$onlyMode) {
          zoom();
        }
      });
    }
  }
}
